import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import CircularProgressbar from '@mui/material/CircularProgress';
import { useUpdateOrientationMutation, useCreateGroupMutation, useUpdateLayoutMutation} from '../../../Redux/service/AllEmpData';
import { GetCookie } from '../../../Libraries/Post/GetAllPostRelatedToScreen/AllPosts/index';


const orientationOptions = [
  { label: "Landscape", value: "LANDSCAPE" },
  { label: "Portrait Left", value: "PORTRAIT_LEFT" },
  { label: "Portrait Right", value: "PORTRAIT_RIGHT" },
];

export default function SettingsContent({currentScreen , layout , onScreenUpdate}) {
  console.log(currentScreen);
  const [updateorientation] = useUpdateOrientationMutation();
  const [updateLayout] = useUpdateLayoutMutation();
  const [selectedOrientation, setSelectedOrientation] = useState("");
  const [assignGroup] = useCreateGroupMutation();
  const [groupOptions, setGroupOptions] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");
  const navigate = useNavigate();
  const [noGroups, setNoGroups] = useState(false);
  const [settingsLoading, setSettingsLoading] = useState(false);
  

  

  const handleOrientationSave = async (newOrientation) => {
    if (!currentScreen || !newOrientation) {
      toast.error("Orientation not selected");
      return;
    }

    const orientationMap = {
      LANDSCAPE: {
        txt_orientation_type: "LANDSCAPE",
        txt_orientation_type_detail: "LANDSCAPE",
      },
      PORTRAIT_LEFT: {
        txt_orientation_type: "PORTRAIT",
        txt_orientation_type_detail: "PORTRAIT_LEFT",
      },
      PORTRAIT_RIGHT: {
        txt_orientation_type: "PORTRAIT",
        txt_orientation_type_detail: "PORTRAIT_RIGHT",
      },
    };

    const orientationPayload = orientationMap[newOrientation];

    if (!orientationPayload) {
      toast.error("Invalid orientation selected");
      return;
    }

    const { txt_orientation_type, txt_orientation_type_detail } = orientationPayload;

    const safePattern = /^[A-Z_]+$/;
    if (!safePattern.test(txt_orientation_type) || !safePattern.test(txt_orientation_type_detail)) {
      toast.error("Invalid orientation format");
      return;
    }

    try {
      const customerId = localStorage.getItem("txt_customer_id");
      const securityToken = await GetCookie("es_token");

      const formData = new FormData();
      // formData.append("ser_collection_id", currentScreen.ser_collection_id);
      formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
      formData.append("security_token", await GetCookie("es_token"));
      formData.append("ser_code_id", currentScreen.ser_code_id);
      formData.append("txt_orientation_type", txt_orientation_type);
      formData.append("txt_orientation_type_detail", txt_orientation_type_detail);

      const response = await updateorientation(formData).unwrap();

      if (response.status === "true") {
        toast.success(response.message);
        if (txt_orientation_type === "PORTRAIT" && onScreenUpdate) {
           await onScreenUpdate(); 
        if (currentScreen.ser_screen_id) {
          const layoutForm = new FormData();
          layoutForm.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
          layoutForm.append("security_token", await GetCookie("es_token"));
          layoutForm.append("ser_screen_id", currentScreen.ser_screen_id);
          if(layout > 2){
            layoutForm.append("ser_layout_id", 1); 
          }
          await updateLayout(layoutForm).unwrap();
          if(layout > 2){
            if (onScreenUpdate) onScreenUpdate(1); 
          }
        }
      } else if (onScreenUpdate) {
        onScreenUpdate(); 
      }
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Mutation error:", error);
      toast.error("Something went wrong while updating orientation.");
    }
  };
  const getAllGroups = async () => {
    try {
      const customerId = localStorage.getItem("txt_customer_id");
      const securityToken = await GetCookie("es_token");

      const formData = new FormData();
      formData.append("function", "GET_ALL_GROUPS");
      formData.append("txt_customer_id", customerId);
      formData.append("security_token", securityToken);

      const response = await assignGroup(formData);
      if (response.data.status === "true") {
        const groups = response.data.data;
        setGroupOptions(groups);
        setNoGroups(false);
      } 
      else if (response.data.message === "No Groups available") {
        setGroupOptions([]);
        setNoGroups(true);
      } 
      else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
      toast.error("Failed to fetch groups");
    }
  };

  const handleGroupChange = async (e) => {
    const groupId = e.target.value;
    const customerId = localStorage.getItem("txt_customer_id");
    const formData = new FormData();
    formData.append("function", "ASSIGN_GROUP");
    formData.append("txt_customer_id", customerId);
    formData.append("ser_collection_id", groupId);
    formData.append("screen_ids", JSON.stringify([currentScreen.ser_screen_id]));
    formData.append("security_token", await GetCookie("es_token")); 

    try {
      const response = await assignGroup(formData);
      if (response.data.status === "true") {
        toast.success(response.data.message);
        setSelectedGroup(groupId);
        await onScreenUpdate();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error assigning group:", error);
      toast.error("Failed to assign group");
    }
  };
  const handleUnassignGroup = async (groupId) => {
  if (!selectedGroup) return;

  setSelectedGroup("");
 

  try {
    const customerId = localStorage.getItem("txt_customer_id");
    const formData = new FormData();
    formData.append("function", "UNASSIGN_GROUP");
    formData.append("txt_customer_id", customerId);
    formData.append("ser_collection_id", groupId);
    formData.append("ser_screen_id", currentScreen.ser_screen_id);
    formData.append("security_token", await GetCookie("es_token"));

    const response = await assignGroup(formData);

    if (response.data.status === "true") {
      toast.success("Group unassigned successfully");
      if (onScreenUpdate) {
        await onScreenUpdate();
      }
      await getAllGroups();

    } else {
      toast.error(response.data.message);
    }
  } catch (error) {
    console.error("Error unassigning group:", error);
    toast.error("Failed to unassign group");
  }
};

  // const handleUnassignGroup = async (groupId) => {
  //   if (!selectedGroup) return; 

  //   setSelectedGroup(""); 

  //   try {
  //     const customerId = localStorage.getItem("txt_customer_id");
  //     const formData = new FormData();
  //     formData.append("function", "UNASSIGN_GROUP"); 
  //     formData.append("txt_customer_id", customerId);
  //     formData.append("ser_collection_id", groupId);
  //     formData.append("ser_screen_id", [currentScreen.ser_screen_id]);
  //     formData.append("security_token", await GetCookie("es_token"));

  //     const response = await assignGroup(formData);

  //     if (response.data.status === "true") {
  //       toast.success("Group unassigned successfully");
  //     } else {
  //       toast.error(response.data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error unassigning group:", error);
  //     toast.error("Failed to unassign group");
  //   }
  // };
  useEffect(() => {
    if (!currentScreen) return;

    const loadSettings = async () => {
      setSettingsLoading(true);

      setSelectedOrientation(
        currentScreen.txt_orientation_type_detail || ""
      );

      await getAllGroups();
      if (currentScreen.ser_collection_id) {
        setSelectedGroup(String(currentScreen.ser_collection_id));
      }

      setSettingsLoading(false);
    };

    loadSettings();
  }, [currentScreen]);
  useEffect(() => {
  if (currentScreen?.ser_collection_id) {
    setSelectedGroup(String(currentScreen.ser_collection_id));
  } else {
    setSelectedGroup("");
  }
}, [currentScreen?.ser_collection_id]);


  return (
    <Box sx={{ background: "#F4F6F8", borderRadius: "16px"}}>
      {settingsLoading ? (
                  <Box
                      sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          minHeight: "200px", 
                      }}
                  >
                      <div style={{ width: 80, height: 80 }}>
                          <CircularProgressbar />
                      </div>
                  </Box>
              ) : (

        <Box className="flex flex-column px-3 py-4 gap-3 mt-2" sx={{background: '#F4F6F8', borderRadius: '16px'}} >
          <FormControl fullWidth className="flex gap-2">
            <Box component={'span'} sx={{fontSize: '14px', fontWeight: '600' , color:'#000000AB'}}>Orientation</Box>
            <Select
              labelId="orientation-select-label"
              value={selectedOrientation}
              onChange={async (e) => {
                const value = e.target.value;
                setSelectedOrientation(value);
                await handleOrientationSave(value); 
              }}
              sx={{
                backgroundColor: "#FCFCFD",
                borderRadius: "10px",
                fontSize: "12px",
                height: "35px",
                "&:hover .MuiOutlinedInput-notchedOutline": {
                            border: '1px solid #63a1ed'
                }
              }}
            >
              {orientationOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
{/* 
          <FormControl fullWidth>
            <Box sx={{ fontSize: "14px", fontWeight: 600, mb: 1 }}>
              Assign Group
            </Box>

            {noGroups ? (
              <Box
                onClick={() => navigate("/groups")}
                sx={{
                  backgroundColor: "#1a75e8",
                  color: "#fff",
                  borderRadius: "10px",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: 500,
                }}
              >
                Create Group
              </Box>
            ) : (
              <Select
                value={selectedGroup || ""}
                onChange={handleGroupChange}
                displayEmpty
                // renderValue={(selected) => {
                //   if (!selected) return "Assign Group";
                //   const group = groupOptions.find(
                //     (g) => g.ser_collection_id === selected
                //   );
                renderValue={(selected) => {
                  if (!selected) return "Assign Group";

                  const group = groupOptions.find(
                    (g) => String(g.ser_collection_id) === String(selected)
                  );
                  const name =
                    group?.txt_collection_name ||
                    `Group (${selected})`;

                  return (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span>{name}</span>

                      <Box
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          handleUnassignGroup(selectedGroup);
                        }}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </Box>
                    </Box>
                  );
                }}
                sx={{
                  backgroundColor: "#FCFCFD",
                  borderRadius: "10px",
                  fontSize: "12px",
                  height: "35px",
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#63a1ed",
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Assign Group
                </MenuItem>

                {groupOptions?.map((group) => (
                  <MenuItem
                    key={group.ser_collection_id}
                    value={group.ser_collection_id}
                  >
                    {group.txt_collection_name}
                  </MenuItem>
                ))}
              </Select>
            )}
          </FormControl> */}
          <FormControl fullWidth>
            <Box sx={{ fontSize: "14px", fontWeight: 600, mb: 1 }}>
              Assign Group
            </Box>

            {noGroups ? (
              <Box
                onClick={() => navigate("/groups")}
                sx={{
                  backgroundColor: "#1a75e8",
                  color: "#fff",
                  borderRadius: "10px",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: 500,
                }}
              >
                Create Group
              </Box>
            ) : selectedGroup ? (
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "#E8F0FE",
                  borderRadius: "10px",
                  px: "7%",
                  py: "3%",
                  fontSize: "12px",
                  border: "1px solid #D0D5DD"
                  
                }}
              >
                <span><b>
                  {
                    groupOptions.find(
                      (g) => String(g.ser_collection_id) === String(selectedGroup)
                    )?.txt_collection_name || "Group"
                  }
                  </b>
                </span>

                <Box
                  onClick={() => handleUnassignGroup(selectedGroup)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <CloseIcon fontSize="small" />
                </Box>
              </Box>
            ) : (
              <Select
                value={selectedGroup || ""}
                onChange={handleGroupChange}
                displayEmpty
                sx={{
                  backgroundColor: "#FCFCFD",
                  borderRadius: "10px",
                  fontSize: "12px",
                  height: "35px",
                }}
              >
                <MenuItem value="" disabled>
                  Assign Group
                </MenuItem>

                {groupOptions?.map((group) => (
                  <MenuItem
                    key={group.ser_collection_id}
                    value={group.ser_collection_id}
                  >
                    {group.txt_collection_name}
                  </MenuItem>
                ))}
              </Select>
            )}
          </FormControl>



        </Box>
      )}
    </Box>
  );
}
